<div class="page-header-main">
  <div class="row align-items-center justify-content-between">
    <div class="col-md-auto col-sm-auto col">
      <div class="content-header">
        <h1>Category And Sub Category</h1>
      </div>
    </div>
    <div class="col-md-auto col-sm-auto col-auto">
      <button class="btn blue-btn btn-sm" (click)="manageCategory({})">
        <i class="fas fa-plus"></i> Add Category
      </button>
    </div>
  </div>
</div>

<div class="table-responsive">
  <table
    mat-table
    [dataSource]="categories"
    multiTemplateDataRows
    class="table table-bordered"
  >
    <!-- Expand Icon -->
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <mat-icon class="cursor-pointer" (click)="toggleRow(element)">
          {{ expandedElement === element ? "expand_more" : "chevron_right" }}
        </mat-icon>
      </td>
    </ng-container>

    <!-- Category Name -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.categoryName }}</td>
    </ng-container>

    <!-- Status -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">
        {{ element.isActive ? "Active" : "Inactive" }}
      </td>
    </ng-container>
    <!-- Action -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon class="interButtonIcons text-success" (click)="manageCategory(element)">edit</mat-icon>
        <!-- <mat-icon class="interButtonIcons text-danger" (click)="deleteCategory(element)">delete</mat-icon> -->
      </td>
    </ng-container>

    <!-- SubCategory Row -->
    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let category"
        [attr.colspan]="columnsToDisplay.length"
      >
        <div
          [@detailExpand]="
            expandedElement === category ? 'expanded' : 'collapsed'
          "
          class="example-element-detail"
        >
          <div
            *ngIf="expandedElement === category"
            class="inner-table mat-elevation-z8"
          >
            <div class="row mb-3 align-items-center justify-content-between">
              <div class="col-md-auto">
                <h2>Sub Category</h2>
              </div>
              <div class="col-md-auto">
                <button
                  class="btn blue-btn btn-sm"
                  (click)="addSubCategory(category)"
                >
                  <i class="las la-plus"></i> Add SubCategory
                </button>
              </div>
            </div>

            <table
              mat-table
              [dataSource]="subCategories"
              class="table table-bordered"
            >
              <!-- SubCategory Name -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let sub">{{ sub.subCategoryName }}</td>
              </ng-container>

              <!-- Index -->
              <!-- <ng-container matColumnDef="nIndex">
                <th mat-header-cell *matHeaderCellDef>Index</th>
                <td mat-cell *matCellDef="let sub">{{ sub.nIndex }}</td>
              </ng-container> -->

              <!-- Status -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let sub">
                  {{ sub.isActive ? "Active" : "Inactive" }}
                </td>
              </ng-container>

              <!-- Action -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let sub">
                  <mat-icon class="interButtonIcons text-success" (click)="manageCategory(sub)">edit</mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="subCategoryColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: subCategoryColumns"
              ></tr>
            </table>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Rows -->
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="example-detail-row"
    ></tr>
  </table>
</div>
<mat-paginator
  [length]="totalItems"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [pageSizeOptions]="[5, 10, 25, 50]"
  (page)="onPageChange($event)"
  aria-label="Select page"
>
</mat-paginator>
